/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import { getOverrideFontFamily } from '../../token/shared/common/fontfamilies.token';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

// Your Styles goes here and use token ex: ${token?.button_primary_background_color}

*/
const CpdsSweepstakesFormsToolkitsInputsStyleTag = styled.div`
  ${({ theme: { styles : {cpds} }, props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
   
    return css`   
      ${(props) => props?.styleOverrides}
    `}
  }
`;

const CpdsSweepstakesFormsToolkitsInputFieldsWrapper = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const applyStyleOverrides = props?.styleOverrides;
    return css`
    width: ${props.inputWidth || '50%'};
    &.invalid .text-field-wrapper,  &.invalid .text-select-wrapper {
      border-color: ${token?.input_fields_error_border_color || 'red'};
    }
    ${applyStyleOverrides}
  `}
  }
`;

const FlexRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CpdsSweepstakesFormsToolkitsLabelWrapper = styled.div`
  ${FlexRow}
  margin-bottom: 8px;
`;

const CpdsSweepstakesFormsToolkitsLabel = styled.label`
  ${({ theme: { styles: { cpds } }, isDisabled, themeColorMode, isOverRideTypography = false }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, themeColorMode);

    const labelStyles = isDisabled
      ? {
        color: '#676A7D',
      }
      : {
        color: token?.input_fields_label_color || '#0C0E1C',
      };

    return css`
      text-align: left;
      padding-right: 6px;
      font-size: 14px !important;
      line-height: 20px !important;;
      color: ${labelStyles.color};
      & > p {
        ${isOverRideTypography && css`
          color: ${labelStyles.color};
      `}
      }
     
    `;
  }}
`;

const CpdsSweepstakesFormsToolkitsTextFieldWrapper = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;
    const { borderType } = props;
    return css`
    height: 32px;
    border: 1px solid ${isDisabled ? token?.input_fields_disable_border_color : token?.input_fields_border_color || '#D1D5E2'};
    border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 
    background-color: white;
    ${FlexRow}
    justify-content: space-between;
    &.search {
      justify-content:flex-start;
    }
    padding: 0 17.33px 0 16px;
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsTextField = styled.input`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;

    const inputStyles = isDisabled
      ? {
        fontSize: token?.input_fields_disable_font_size || '14px',
        fontWeight: token?.input_fields_disable_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_disable_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
      }
      : {
        fontSize: token?.input_fields_font_size || '14px',
        fontWeight: token?.input_fields_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
      };

    return css`
      height: 100%;
      background: transparent;
      padding-right: 15px;
      width: 100%;
      outline: none;
      cursor: text;
      color: ${inputStyles.color};
      font-size: ${inputStyles.fontSize};
      font-weight: ${inputStyles.fontWeight};
      line-height: ${inputStyles.lineHeight};
      &::placeholder {
        color: ${inputStyles.pHFontColor};
        font-size: ${inputStyles.pHFontSize};
        font-weight: ${inputStyles.pHfontWeight};
        line-height: ${inputStyles.pHlineHeight};
        opacity: 1;
      }
       
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsHelperTextWrapper = styled.div`
  padding-top: 5px;
  ${FlexRow}
`;

const CpdsSweepstakesFormsToolkitsHelperLabel = styled.p`
  ${({ theme: { styles: { cpds } }, isDisabled, isOverRideTypography, isError, themeColorMode }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, themeColorMode);

    const labelStyles = isDisabled
      ? {
        lineHeight: token?.input_fields_helper_label_disable_line_height || '20px',
        color: token?.input_fields_helper_label_disable_font_color || '#0C0E1C',
      }
      : {
        lineHeight: token?.input_fields_helper_label_line_height || '20px',
        color: token?.input_fields_helper_label_color || '#0C0E1C',
      };

    const errorColor = token?.input_fields_error_label_color || '#C01E1E';

    return css`
      text-align: left;
      padding-left: 6px;
      color: ${isError ? errorColor : labelStyles.color}; 
      ${isOverRideTypography && css` && {
          line-height: ${labelStyles.lineHeight};
          font-family: ${getOverrideFontFamily(token.accordion_body_style1_description_font_family_key)};
        }
      `}
    `;
  }}
`;

const CpdsSweepstakesFormsToolkitsTextAreaField = styled.textarea`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;

    const inputStyles = isDisabled
      ? {
        fontSize: token?.input_fields_disable_font_size || '14px',
        fontWeight: token?.input_fields_disable_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_disable_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
      }
      : {
        fontSize: token?.input_fields_font_size || '14px',
        fontWeight: token?.input_fields_font_weight || '400',
        lineHeight: '16px',
        color: token?.input_fields_font_color || '#0C0E1C',
        pHFontSize: token?.input_fields_placeholder_font_size || '14px',
        pHfontWeight: token?.input_fields_placeholder_font_weight || '400',
        pHlineHeight: token?.input_fields_placeholder_line_height || '16px',
        pHFontColor : token?.input_fields_placeholder_font_color || '#0C0E1C'
      };

    return css`
      min-height: 94px;
      background: transparent;
      padding-right: 15px;
      width: 100%;
      outline: none;
      cursor: text;
      color: ${inputStyles.color};
      font-size: ${inputStyles.fontSize};
      font-weight: ${inputStyles.fontWeight};
      line-height: ${inputStyles.lineHeight};
      border: none;
      resize: none;
      &::placeholder {
        color: ${inputStyles.pHFontColor};
        font-size: ${inputStyles.pHFontSize};
        font-weight: ${inputStyles.pHfontWeight};
        line-height: ${inputStyles.pHlineHeight};
        opacity: 1;
      }
      &::-webkit-scrollbar {
          width: 0em;
      }
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsLongInputFieldWrapper = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isDisabled } = props;
    const { borderType } = props;
    return css`
    min-height: 112px;
    border: 1px solid ${isDisabled ? token?.input_fields_disable_border_color : token?.input_fields_border_color || '#D1D5E2'};
    border-radius: ${borderType === 'RoundPill' ? '16px' : '8px'};
    background-color: white;
    ${FlexRow}
    justify-content: space-between;
    &.search {
      justify-content:flex-start;
    }
    padding: 8px 0 8px 16px
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: fit-content;
  flex-direction: column;
`;

const CpdsSweepstakesFormsToolkitsCheckboxWrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: fit-content;
`;

const CpdsSweepstakesFormsToolkitsCheckboxGost = styled.div.attrs({
  'data-cy': 'cpds-sweepstake-checkbox'
})<{ Checked: boolean; isDisabled: boolean; isError:boolean }>`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { isDisabled } = props;
    return css`
      display: flex;
      align-items: stretch;
      width: fit-content;
      width: 18px;
      height: 18px;
      border: ${({ Checked, isDisabled }) => (Checked ? 'none' : isDisabled ? '2px solid #D1D5E2' : '2px solid #0C0E1C')};
      border-radius: 2px;
      overflow: hidden;
      -webkit-transition: all 150ms;
      transition: all 150ms;
      position: relative;
      flex-shrink: 0;
      & > svg {
        opacity: ${isDisabled ? '0.6' : '1'};
        position: absolute;
        top: -1px;
        left: -1px;
      }
    `}
  }
`;

const CpdsSweepstakesFormsToolkitsCheckbox = styled.input.attrs({ type: 'checkbox' })<{ checked: boolean; disabled: boolean; isError:boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    appearance: none;
    -webkit-appearance: none; 
    cursor: pointer;
    display: none;
    background: transparent;
    border: 1px solid ${({ isError }) => (isError ? '#C01E1E' : '#0C0E1C')};
    -webkit-transition: all 150ms;
    transition: all 150ms;
    margin-top: 3px;
    &:before {
      background: transparent;
      content: "";
      width: 18px;
      height: 18px;
      position: absolute;
      border: 1px solid white;
      border-radius: 4px;
    }
    &:checked:before {
      background: ${({ checked }) => (checked ? '#0C0E1C' : 'transparent')};
    }
`;

const CpdsSweepstakesFormsToolkitsCheckboxLabel = styled.label<{ disabled: boolean }>`
    ${({ theme: { styles: { cpds } }, ...props }) => {
    const { isDisabled } = props;
    return css`
      margin-left: 12px;
      color: ${isDisabled ? '#676A7D' : '#0C0E1C'};
    `}
  }
`;


const CpdsSweepstakesFormsToolkitsRadioContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: fit-content;
  flex-direction: column;
`;

const CpdsSweepstakesFormsToolkitsRadioWrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: fit-content;
`;

const CpdsSweepstakesFormsToolkitsRadio = styled.input.attrs({ type: 'radio' })<{ checked: boolean; disabled: boolean; isError:boolean }>`
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid ${({ isError }) => (isError ? '#C01E1E' : '#0C0E1C')};
    -webkit-transition: all 150ms;
    transition: all 150ms;
    margin-top: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    display: inline-block;
    position: relative;
    flex-shrink: 0;
    &:checked:before {
      background: ${({ checked, isError }) => (checked ? isError ? '#C01E1E' : '#0C0E1C' : 'transparent')};
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: absolute;
      top: 2px;
      left: 2px;
    }
`;

const CpdsSweepstakesFormsToolkitsRadioLabel = styled.label<{ disabled: boolean }>`
    ${({ theme: { styles: { cpds } }, ...props }) => {
    const { isDisabled } = props;
    return css`
      margin-left: 12px;
      color: ${isDisabled ? '#676A7D' : '#0C0E1C'};
      margin-top: 4px;
    `}
  }
`;

const CpdsSweepstakesFormsToolkitsSelect = styled.select`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isError, borderType } = props;
    return css`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: ${cpds?.input_fields_font_size || '14px'};
    font-weight: ${cpds?.input_fields_font_weight || '500'};
    text-align: left;
    color: ${cpds?.input_fields_font_color || '#31374F'};
    width: 100%;
    border: 1px solid ${isError ? token?.input_fields_error_border_color || 'red' : token?.input_fields_border_color || '#D1D5E2'};
    border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 
    background-color: white;
    padding: 8px 16px;
    padding-right: 40px;
    position: relative;
    &::-ms-expand {
      display: none;
    }
    option {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding: 12px 16px;
    }

      &:hover,
      &:focus {
        border-color: #999;
        outline: none;
      }
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsSelectOptionWrapper = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    return css`
      padding: 12px 16px;
  `}
  }
`;

const Arrow = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isOpen } = props;
    return css`
    content: '';
    position: absolute;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.94 0.726685L4 3.78002L7.06 0.726685L8 1.66668L4 5.66668L0 1.66668L0.94 0.726685Z' fill='%230C0E1C'/%3E%3C/svg%3E%0A");
    top: 50%;
    right: 16px;
    width: 8px;
    height: 6px;
    transform: ${isOpen ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%) rotate(0deg)'};
    transition: transform 0.3s ease;
    pointer-events: none;
  `}
  }
`;

const CpdsSweepstakesFormsToolkitsSelectWrapper = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const applyStyleOverrides = props?.styleOverrides;
    return css`
    width: ${props.inputWidth || '50%'};
    min-height: 32px;
    ${applyStyleOverrides}
  `}
  }
`;

const CpdsSweepstakesSelect = styled.div`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isError, borderType } = props;
    return css `
      position: relative;
      font-size: ${cpds?.input_fields_font_size || '14px'};
      font-weight: ${cpds?.input_fields_font_weight || '500'};
      text-align: left;
      color: ${cpds?.input_fields_font_color || '#31374F'};
      width: 100%;
      border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 
      background-color: white;
      &.large {
        font-size: 20px;
        padding: 15px 30px;
      }
      
      .ScrollbarsCustom-TrackY {
          right: 3px !important;
          top: 14px !important;
          height: calc(100% - 27px) !important;
      }
    `;
  }}
  
`;

const CpdsSweepstakesOptionList = styled.ul`
  width: calc(100% - 8px);
  margin: 0;
  padding: 0;
  list-style: none;
  padding-left: 4px;
`;

const CpdsSweepstakesOptionItem = styled.li<{ isFocused: boolean }>`
  padding: 12px 16px;
  color: #0C0E1C;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${(props) => (props.isFocused ? '#E2E4EC' : 'white')};
  margin-bottom: 2px;
  &:hover {
    background-color: #E2E4EC;
  }
`;

const CpdsSweepstakesSelectButton = styled.button`
  ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isError, borderType } = props;
    return css `
      position: relative;
      width: 100%;
      min-height: 32px;
      padding: 8px 16px;
      font-size: ${cpds?.input_fields_font_size || '12px'};
      font-weight: ${cpds?.input_fields_font_weight || '0'};
      color: ${cpds?.input_fields_font_color || '#31374F'};
      background-color: #FFFFFF;
      border: 1px solid ${isError ? token?.input_fields_error_border_color || 'red' : token?.input_fields_border_color || '#D1D5E2'};
      border-radius: ${borderType === 'RoundPill' ? '40px' : '8px'}; 
      cursor: pointer;
      text-align: left;
      transition: border-color 0.3s ease;
      &:hover {
        border-color: #999;
      }
      &:focus {
        outline: none;
        border-color: #999;
      }
    `;
  }}
  
`;

const CpdsSweepstakesFormsToolkitsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: fit-content;
  flex-direction: column;
`;
// border-color: ${isDisabled ? '#E2E4EC' : token?.input_fields_border_color || '#D1D5E2'};

const CpdsSweepstakesFormsToolkitsPhoneNumberContainer = styled.div`
    ${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { isError, borderType, isDisabled } = props;
    const applyStyleOverrides = props?.styleOverrides;
    return css `
        display: flex;
        flex-direction: row;

        .cpds-input-fields > div {
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            padding: 0 17.33px 0 8px;
            opacity: ${isDisabled ? '0.4' : '1'};
        }

        .cpds-sweepstake-input-select > div > button {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          border-right: none;
          padding: 4px 15px;
        }

        .cpds-sweepstake-input-select > div > div {
          max-width: none;
          width: 160px !important;
          margin-top: 8px;
        }

        .cpds-sweepstake-input-select > div > button > div {
          right: 10px !important;
        }

        .cpds-input-fields > div > input {
          font-family: "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
          font-size: 12px;
          line-height: 16px;
          font-weight: 400;
          font-style: normal;
          color: ${isError ? '#C01E1E' : 'inherit'};
        }       

        ${applyStyleOverrides}
    `;
  }}

`;

export { 
  CpdsSweepstakesFormsToolkitsInputsStyleTag, 
  CpdsSweepstakesFormsToolkitsInputFieldsWrapper, 
  CpdsSweepstakesFormsToolkitsLabelWrapper,
  CpdsSweepstakesFormsToolkitsLabel,
  CpdsSweepstakesFormsToolkitsTextFieldWrapper,
  CpdsSweepstakesFormsToolkitsTextField,
  CpdsSweepstakesFormsToolkitsHelperTextWrapper,
  CpdsSweepstakesFormsToolkitsHelperLabel,
  CpdsSweepstakesFormsToolkitsTextAreaField,
  CpdsSweepstakesFormsToolkitsLongInputFieldWrapper,
  CpdsSweepstakesFormsToolkitsCheckboxContainer,
  CpdsSweepstakesFormsToolkitsCheckboxWrapper,
  CpdsSweepstakesFormsToolkitsCheckbox,
  CpdsSweepstakesFormsToolkitsCheckboxLabel,
  CpdsSweepstakesFormsToolkitsCheckboxGost,
  CpdsSweepstakesFormsToolkitsRadioContainer,
  CpdsSweepstakesFormsToolkitsRadioWrapper,
  CpdsSweepstakesFormsToolkitsRadio,
  CpdsSweepstakesFormsToolkitsRadioLabel,
  CpdsSweepstakesFormsToolkitsSelect,
  CpdsSweepstakesFormsToolkitsSelectWrapper,
  CpdsSweepstakesFormsToolkitsSelectOptionWrapper,
  Arrow,
  CpdsSweepstakesSelect,
  CpdsSweepstakesOptionList,
  CpdsSweepstakesOptionItem,
  CpdsSweepstakesSelectButton,
  CpdsSweepstakesFormsToolkitsContainer,
  CpdsSweepstakesFormsToolkitsPhoneNumberContainer
 };
